<template>
<div class="chapter">
<div class="inner_page">
<h1 class="sigil_not_in_toc" id="pgepubid00004">KAI LUNG’S GOLDEN HOURS</h1>
<p class="calibre1"><a id="link2HCH0001"></a></p>
<div class="c"><br class="calibre2"/>
<br class="calibre2"/>
<br class="calibre2"/>
<br class="calibre2"/></div>
<div class="calibre4" id="calibre_pb_0"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sec001_0003_split_000.vue?02570648